import styles from "./media.module.css";
import { MediaStatus } from "@/lib/media/shared";
import { FiLoader, FiAlertCircle, FiSlash } from "react-icons/fi";

type Props = {
  status: MediaStatus;
  theme?: "light" | "dark";
};

export default function MediaStateOverlay({ status, theme = "light" }: Props) {
  const themeClass = theme === "dark" ? styles.dark : styles.light;

  const isLoading = status === "UPLOADED" || status === "PROCESSING";
  const isFailed = status === "FAILED";
  const isRejected = status === "REJECTED";

  const stateClass = isLoading
    ? styles.loading
    : isFailed
      ? styles.failed
      : isRejected
        ? styles.rejected
        : "";

  return (
    <div className={`${styles.overlay} ${themeClass}`}>
      <div className={`${styles.inner} ${stateClass}`}>
        {/* ICON */}
        <div className={`${styles.icon}`}>
          {isLoading && (
            <div className={styles.pulse}>
              <FiLoader className={styles.spin} />
            </div>
          )}
          {isFailed && <FiAlertCircle />}
          {isRejected && <FiSlash />}
        </div>

        {/* TITLE */}
        <div className={styles.text}>
          <div className={`${styles.title}`}>
            {isLoading && "Processing media"}
            {isFailed && "Upload failed"}
            {isRejected && "File rejected"}
          </div>

          {/* DESCRIPTION */}
          <div className={styles.description}>
            {isLoading && "Please wait while we prepare your file"}
            {isFailed && "Something went wrong while processing"}
            {isRejected && "This file violates our policies"}
          </div>
        </div>
      </div>
    </div>
  );
}
